import { render, staticRenderFns } from "./Slidbar.vue?vue&type=template&id=d2515710&scoped=true"
import script from "./Slidbar.vue?vue&type=script&lang=js"
export * from "./Slidbar.vue?vue&type=script&lang=js"
import style0 from "./Slidbar.vue?vue&type=style&index=0&id=d2515710&prod&lang=less&scoped=true"
import style1 from "./Slidbar.vue?vue&type=style&index=1&id=d2515710&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.1__lodash@4.18.1__ulpx2buzx6ym2m5ug44v2geldi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2515710",
  null
  
)

export default component.exports